import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const isRepeated = (value: string): boolean => /^(\d)\1+$/.test(value);

const validCpf = (value: string): boolean => {
  if (value.length !== 11 || isRepeated(value)) {
    return false;
  }

  // Valida os dois dígitos verificadores: o 1o usa 9 dígitos (pesos 10..2),
  // o 2o usa 10 dígitos (pesos 11..2).
  for (const [baseSize, firstWeight] of [[9, 10], [10, 11]]) {
    let totalSum = 0;
    for (let i = 0; i < baseSize; i++) {
      totalSum += +value.charAt(i) * (firstWeight - i);
    }

    let dv = (totalSum * 10) % 11;
    if (dv === 10) {
      dv = 0;
    }

    if (dv !== +value.charAt(baseSize)) {
      return false;
    }
  }

  return true;
};

const validCnpj = (value: string): boolean => {
  if (value.length !== 14 || isRepeated(value)) {
    return false;
  }

  for (const baseSize of [12, 13]) {
    let totalSum = 0;
    let position = baseSize - 7;

    for (let i = 0; i < baseSize; i++) {
      totalSum += +value.charAt(i) * position--;
      if (position < 2) {
        position = 9;
      }
    }

    const dv = totalSum % 11 < 2 ? 0 : 11 - (totalSum % 11);

    if (dv !== +value.charAt(baseSize)) {
      return false;
    }
  }

  return true;
};

export class RechargeValidators {

  /**
   * Valida CPF ou CNPJ ignorando a máscara. O tamanho do documento é quem
   * decide o tipo, então o toggle "Recarregar com CNPJ" não interfere.
   */
  static documentValidator(): ValidatorFn {

    return (control: AbstractControl): ValidationErrors | null => {
      const digits = (control.value ?? '').toString().replace(/\D/g, '');

      if (!digits) {
        return null;
      }

      const valid = digits.length > 11 ? validCnpj(digits) : validCpf(digits);

      return valid ? null : { documentvalidator: true };
    };
  }

}
